export class PermissionsFormController {
	constructor($timeout, XrayPermissionsDao, $scope, $state, $stateParams, $q, JFrogModal, JFrogGridFactory,
	            commonGridColumns, User,
	            XRayUIModelSaver, JFrogEventBus, JFrogNotifications, uiGridConstants, BinMgrDao,
	            XRayUIStorage, XRayUIPermissions) {
		this.$scope = $scope;
		this.gridsCreated = false;
		this.XRayUIStorage = XRayUIStorage;
		this.XRayUIPermissions = XRayUIPermissions;
		this.binMgrDao = BinMgrDao;
		this.$q = $q;
		this.uiGridConstants = uiGridConstants;
		this.jFrogNotifications = JFrogNotifications;
		this.$timeout = $timeout;
		this.commonGridColumns = commonGridColumns;
		this.user = User.getCurrent();
		this.modal = JFrogModal;
		this.permissionsDao = XrayPermissionsDao;
		this.$stateParams = $stateParams;
		this.showAdminNotif = false;
		this.$state = $state;
		this.getAuthInstance();
		this.initPermissionForm();
		this._getInstancesAndResources();
		this._getGroups();
		this._getUsers();
		this.artifactoryGridFactory = JFrogGridFactory;
		this.XrayModelSaver = XRayUIModelSaver.createInstance(this, ['permission']);
		this._createGroupsGrid();
		this._createUsersGrid();
		this.XrayModelSaver.save();
		this.JFrogEventBus = JFrogEventBus;
		this.dndComm = {};
		this.fetchingResources = true;
		this.resourcesFetchStatus = 'Fetching Resources';


	}//end ctor

	getAuthInstance() {
		this.binMgrDao.get().$promise.then(instances => {

			this.authIntsance = _.filter(instances, 'is_access');
		});
	}

    dismissPermissionMessage() {
        this.XRayUIStorage.setItem('dismiss_permissions_message', true);
    }

	_transformResourcesObj(arr) {

		_.each(arr, (val, key) => {
			let tmpObj = {};
			tmpObj.name = val.name;
			tmpObj.resources = [];
			let instaceName = val.name;

			_.each(val.resources, (resourceVal, repoKey) => {
				let tmpResourceObj = resourceVal;
				tmpResourceObj.name = `${instaceName}::${resourceVal.name}`;
				tmpResourceObj = this.getRepoWithIcon(tmpResourceObj);
				tmpObj.resources.push(tmpResourceObj);
			});
			arr[key] = tmpObj;
		});
	}

	initPermissionForm() {
		this.groupsGrid = [];
		this.usersGrid = [];
		this.selectedItems = [];
		this.TOOLTIP = {};
		this.groupsGridOption = {};
		this.usersGridOption = {};
		this.allResourcesFlatten = [];
		this.permission = {};
		this.currentTab = 'resources';
		this.permission.resource_type = 'resources';
		this.resourceFilter = {};
		this.resourceFilter.currentResourceType = 'All';
		this.resourceFilter.currentRepoType = 'All';
		this.reposTypes = ['All', 'Local', 'Remote'];
		this.resourcesTypes = ['All', 'Repository', 'Build'];
		if (this.$stateParams.permissionName) {
			this.mode = 'edit';
			this.title = 'Edit Rule';
			this.newPermission = false;
			this.permission.name = this.$stateParams.permissionName;
		} else {
			this.title = 'New Permission';
			this.mode = 'new';
			this.newPermission = true;
		}
	}

	_getInstancesAndResources() {
		let hasData = false;
		this.CurrentPermissionResources = {};
		let count = 0;
		this._getBuilds().then((response) => {
			this.CurrentPermissionResources.builds = _.cloneDeep(response);
			if (count == 0) {
				this._setResources(response);
			} else {
				hasData = true;
				if (response.data) {
					let finalData = this.CurrentPermissionResources.repos.data.concat(
						this.CurrentPermissionResources.builds.data);
					if (hasData) {
						this._setResources({data: finalData});
					}

				}
				if (this.$stateParams.permissionName) {
					this.getPermissionData();
					/** In case of permission edit - the getPermission method will get called  **/
					this.getFilterResources();
				} else {
					this.getFilterResources();
				}
				this.resourcesFetchStatus = 'Fetch Done';
				this.fetchingResources = false;
			}
			count++;

		});

		this._getRepos().then((response) => {
			this.CurrentPermissionResources.repos = _.cloneDeep(response);
			if (count == 0) {
				this._setResources(response);
			} else {
				if (response.data) {
					let finalData = this.CurrentPermissionResources.repos.data.concat(
						this.CurrentPermissionResources.builds.data);
					this._setResources({data: finalData});

				}
				if (this.$stateParams.permissionName) {
					this.getPermissionData();
					/** In case of permission edit - the getPermission method will get called  **/
					this.getFilterResources();
				} else {
					this.getFilterResources();
				}

				this.resourcesFetchStatus = 'Fetch Done';
				this.fetchingResources = false;
			}
			count++;
		});

	}

	_getRepos() {
		let defer = this.$q.defer();
		this.permissionsDao.getInstances({repos: true, $no_spinner: true}).$promise.then((response) => {

			defer.resolve(response);

		});

		return defer.promise;
	}

	_getBuilds() {
		let defer = this.$q.defer();

		this.permissionsDao.getInstances({builds: true, $no_spinner: true}).$promise.then((response) => {
			defer.resolve(response);
		});
		return defer.promise;
	}

	_setResources(response) {

		this.availableInstances = response.data;
		this._transformResourcesObj(this.availableInstances);
		this.allResourcesFlatten = _.flatten(_.map(response.data, 'resources'), true);
		this.availableInstances = _.uniq(_.map(this.availableInstances, 'name'));

		this.availableInstances.unshift('All');
		this.resourceFilter.currentInstance = 'All';

	}

	/** Available Resource Filter Method  **/
	getFilterResources() {
		this.filteredResources = [];
		if (this.resourceFilter.currentResourceType.toLowerCase() == 'all' || this.resourceFilter.currentResourceType.toLowerCase() == 'build') {
			this.resourceFilter.currentRepoType = 'All';
		}
		let showAll = _.isEqual(this.resourceFilter.currentInstance, this.resourceFilter.currentRepoType) && _.isEqual(
			this.resourceFilter.currentInstance, this.resourceFilter.currentResourceType);


		if (showAll) {

			this.filteredResources = this.allResourcesFlatten;
		}
		else {
			this.filteredResources = this.allResourcesFlatten;
			if (this.resourceFilter.currentInstance.toLowerCase() !== 'all') {

				this.filteredResources = _.filter(this.allResourcesFlatten, (n) => {
					return n.name.split('::')[0].toLowerCase() == this.resourceFilter.currentInstance.toLowerCase();
				});
			}
			if (this.resourceFilter.currentResourceType.toLowerCase() !== 'all') {

				this.filteredResources = _.filter(this.filteredResources, (n) => {

					if (this.resourceFilter.currentResourceType.toLowerCase() === 'build') {
						return n.type.toLowerCase() === 'build';
					}
					return n.type.toLowerCase() !== 'build';
				});
			}

			if (this.resourceFilter.currentRepoType.toLowerCase() !== 'all') {

				this.filteredResources = _.filter(this.filteredResources, (n) => {


					return n.type.toLowerCase() == this.resourceFilter.currentRepoType.toLowerCase();
				});
			}

		}

		this._filterAvailableUsers();
		this._filterAvailableGroups();
		this._filterAvailableResources();
	}

	/** Get All Groups Method **/
	_getGroups() {

		this.permissionsDao.getGroups({$no_spinner: true}).$promise.then((response) => {

			this.allGroups = response.data.groups;
			this.availableGroups = response.data.groups;


			_.each(response.data.groups, (value, key) => {

				this.availableGroups[key].name = this.availableGroups[key].group_name;
				this.availableGroups[key].clickable = true;
				delete this.availableGroups[key].group_name;
			});

			this._filterAvailableUsers();
			this._filterAvailableGroups();
		});
	}

	/** Get All Users Method **/
	_getUsers() {

		this.permissionsDao.getUsers({$no_spinner: true}).$promise.then((response) => {
			this.allUsers = response.data;
			this.availableUsers = response.data;
			_.each(response.data, (value, key) => {
				this.availableUsers[key].clickable = true;
			});


		});
	}

	/** Get Data of specific permission Method **/
	getPermissionData() {

		this.permissionsDao.getPermission({}, {permissionName: this.$stateParams.permissionName}).$promise.then(
			(permission) => {

				//console.log('Permission is',permission)
				//console.log("Transofrming in two minutes");
				//console.log("about to do the transform")
				this._transformForEdit(permission);


				//this._filterAvailableResources();

				this.$timeout(() => {
					this.showAdminNotif = true;
				}, 500);

			}).catch(() => this.savePending = false);

	}

	formInvalid() {

		if (this.permission.resource_type == 'global') {

			return this.savePending || this.form.$invalid;
		}
		return this.savePending || this.form.$invalid || !this.permission.resources || !this.permission.resources.length || this.isModelChanged(
			this.permission, this.XrayModelSaver.savedModels.permission);
	}

	isModelChanged(obj1, obj2) {


		let isEqual = _.isEqual(obj1, obj2, (value, other) => {

			delete value.$$hashKey;
			delete other.$$hashKey;

			return _.isEqual(value, other);

		});

		return isEqual;
	}


	getRepoWithIcon(repo) {
		repo._iconClass = 'icon ' + (repo.type === 'local' ? 'icon-local-repo' :
			(repo.type === 'remote' ? 'icon-remote-repo' : (repo.type === 'virtual' ? 'icon-virtual-repo' :
				(repo.type === 'distribution' ? 'icon-distribution-repo' :
					'icon-builds-new'))));
		return repo;
	}

	/**check and set current tab**/

	setCurrentTab(tab) {

		if (!this.gridsCreated) {
			this._createGroupsGrid();
			this._createUsersGrid();
			this.gridsCreated = true;
		}
		this._filterAvailableGroups();
		this._filterAvailableUsers();
		this.count++;
		if (!this.isCurrentTab(tab)) {
			this.currentTab = tab;
		}

	}

	isCurrentTab(tab) {
		return this.currentTab === tab;
	}


	addGroup(group) {
		if (!this.permission.groups) {
			this.permission.groups = [];
		}
		this.permission.groups.push(group);
		this._filterAvailableGroups();

		if (group.name) {
			this.availableGroups = _.remove(this.availableGroups, (g) => {

				return g.name != group.name;
			});
			this.groupsGrid.push({name: group.name});
		}
		else {
			this.availableGroups = _.remove(this.permission.groups, group);
			this.groupsGrid.push(group);
		}


	}

	addUser(user) {
		if (user.icon_class && user.icon_class.indexOf('admin') >= 0) {
			return;
		}

		if (!this.permission.users) {
			this.permission.users = [];
		}
		this.permission.users.push(user);
		this.usersGridOption.setGridData(this.permission.users);
		this._filterAvailableUsers();
	}


	_createGroupsGrid() {
		this.groupsGridOption = this.artifactoryGridFactory.getGridInstance(this.$scope)
		                            .setRowTemplate('default')
		                            .setMultiSelect()
		                            .setColumns(this._getGroupsColumns())
		                            .setButtons(this._getGroupsActions())
		                            .setGridData([])
		                            .setRowsPerPage(10)
		                            .setBatchActions(this._getGroupsBatchActions());
	}

	_createUsersGrid() {
		this.usersGridOption = this.artifactoryGridFactory.getGridInstance(this.$scope)
		                           .setRowTemplate('default')
		                           .setMultiSelect()
		                           .setColumns(this._getUsersColumns())
		                           .setGridData([])
		                           .setRowsPerPage(10)
		                           .setButtons(this._getUsersActions())
		                           .setBatchActions(this._getUsersBatchActions());

		this.usersGridOption.isRowSelectable = (row) => {
			return row.entity.name !== this.user.name;
		};
	}

	_getUsersColumns() {
		return [
			{
				name: 'User',
				displayName: 'User',
				field: 'name',
				cellTemplate: `<div class="name-cell ui-grid-cell-contents">
                                    <i ng-class="row.entity.rules.icon_class ? row.entity.rules.icon_class : 'icon-blank'"
                                       jf-tooltip="{{( row.entity.rules.icon_class && row.entity.rules.icon_class.indexOf('admin') >= 0 ) ? 'Admin Privlages' : row.entity.rules.icon_tooltip}}"
                                       class="icon pull-left"></i>
                                       <span>{{row.entity.name}}</span>
                               </div>`,
				sort: {
					direction: this.uiGridConstants.ASC
				}
			},
			{
				name: 'Admin',
				displayName: 'Admin',
				field: 'admin',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.admin',
                    'row.entity.rules.admin?row.entity.rules.manage_policies=row.entity.rules.view_reports=row.entity.rules.view_component=row.entity.rules.manage_component=row.entity.rules.view_watch_issues=row.entity.rules.manage_watch_issues=true:row.entity.rules.manage_policies=row.entity.rules.view_reports=row.entity.rules.view_component=row.entity.rules.manage_component=row.entity.rules.view_watch_issues=row.entity.rules.manage_watch_issues=false',
					'grid.appScope.PermissionForm.isDisable(row.entity.rules)'),
				isVisible: () => {
					return this.permission.resource_type == 'global';
				}
            },
            {
                name: 'Manage Policies',
                displayName: 'Manage Policies',
                field: 'manage_policies',
                cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.manage_policies', null, 'row.entity.rules.admin'),
                isVisible: () => {
                    return this.permission.resource_type == 'global';
                }

            },
			{
				name: 'Generate Reports',
				displayName: 'View Reports',
				field: 'view_reports',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.view_reports',
					'row.entity.rules.view_reports?row.entity.rules.view_component=true:null',
					'row.entity.rules.admin'),
				isVisible: () => {
					return this.permission.resource_type == 'global';
				}

			},
			{
				name: 'Manage Components',
				displayName: 'Manage Components',
				field: 'manage_component',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.manage_component',
					'row.entity.rules.manage_component?row.entity.rules.view_component=true:null',
					'row.entity.rules.admin')
			},
			{
				name: 'View Components',
				displayName: 'View Components',
				field: 'viewComponent',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.view_component',
					null,
					'row.entity.rules.manage_component || row.entity.rules.view_reports || row.entity.rules.admin ||' +
					' row.entity.rules.manage_watch_issues || row.entity.rules.view_watch_issues')
			},
			{
				name: 'Manage Watches/Issues',
                displayName:
                    'Manage Watches',
				field: 'manage_watch',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.manage_watch_issues',
					'row.entity.rules.manage_watch_issues?row.entity.rules.view_component = ' +
					' row.entity.rules.view_watch_issues=true:null',
					'row.entity.rules.admin')
			},
			{
				name: 'View Watches/Issues',
                displayName:
                    'View Watches',
				field: 'view_watch_issues',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.view_watch_issues',
					'row.entity.rules.view_watch_issues?row.entity.rules.view_component=true:null',
					'row.entity.rules.manage_watch_issues || row.entity.rules.admin')
			}


		];
	}

	_getGroupsColumns() {
		return [
			{
				name: 'Group',
				displayName: 'Group',
				field: 'name',
				cellTemplate: `<div class="name-cell ui-grid-cell-contents">
                                    <i ng-class="row.entity.rules.icon_class ? row.entity.rules.icon_class : 'icon-blank'"
                                       jf-tooltip="{{( row.entity.rules.icon_class && row.entity.rules.icon_class.indexOf('admin') >= 0 ) ? 'Admin Privlages' : row.entity.rules.icon_tooltip}}"
                                       class="icon pull-left"></i>
                                       <span>{{row.entity.name}}</span>
                               </div>`,
				sort: {
					direction: this.uiGridConstants.ASC
				}
			},
			{
				name: 'Admin',
				displayName: 'Admin',
				field: 'admin',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.admin',
                    'row.entity.rules.admin?row.entity.rules.manage_policies=row.entity.rules.view_reports=row.entity.rules.view_component=row.entity.rules.manage_component=row.entity.rules.view_watch_issues=row.entity.rules.manage_watch_issues=true:null',
					'grid.appScope.PermissionForm.isDisable(row.entity.rules)'),
				isVisible: () => {
					return this.permission.resource_type == 'global';
				}
            },
            {
                name: 'Manage Policies',
                displayName: 'Manage Policies',
                field: 'manage_policies',
                cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.manage_policies',
                    null, 'row.entity.rules.admin'),
                isVisible: () => {
                    return this.permission.resource_type == 'global';
                }

            },
			{
				name: 'Generate Reports',
				displayName: 'View Reports',
				field: 'view_reports',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.view_reports',
					'row.entity.rules.view_reports?row.entity.rules.view_component=true:null',
                    'row.entity.rules.admin'),
				isVisible: () => {
					return this.permission.resource_type == 'global';
				}

			},
			{
				name: 'Manage Components',
				displayName: 'Manage Components',
				field: 'manage_component',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.manage_component',
					'row.entity.rules.manage_component?row.entity.rules.view_component=true:null',
                    'row.entity.rules.admin')
			},
			{
				name: 'View Components',
				displayName: 'View Components',
				field: 'viewComponent',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.view_component',
					null,
					'row.entity.rules.manage_component || row.entity.rules.view_reports || row.entity.rules.admin ||' +
					' row.entity.rules.manage_watch_issues || row.entity.rules.view_watch_issues')
			},
			{
                name: 'Manage Watches',
				displayName: 'Manage Watches/Issues',
				field: 'manage_watch',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.manage_watch_issues',
					'row.entity.rules.manage_watch_issues?row.entity.rules.view_component = ' +
					' row.entity.rules.view_watch_issues=true:null',
					'row.entity.rules.admin')
			},
			{
                name: 'View Watches',
				displayName: 'View Watches/Issues',
				field: 'view_watch_issues',
				cellTemplate: this.commonGridColumns.checkboxColumn('row.entity.rules.view_watch_issues',
					'row.entity.rules.view_watch_issues?row.entity.rules.view_component=true:null',
					'row.entity.rules.manage_watch_issues || row.entity.rules.admin')
			}


		];
	}

	_getUsersBatchActions() {

		return [
			{
				icon: 'clear',
				name: 'Remove',
				callback: () => this._deleteSelectedUsers()
			}
		];
	}

	_getGroupsBatchActions() {
		return [
			{
				icon: 'clear',
				name: 'Remove',
				callback: () => this._deleteSelectedGroups()
			}
		];
	}

	_deleteSelectedGroups() {
		let self = this;
		let selectedGroups = this.groupsGridOption.api.selection.getSelectedRows();
		let confirmMessage = 'Are you sure you wish to delete ' + selectedGroups.length;

		selectedGroups.forEach((group) => {
			_.remove(this.permission.groups, group);
		});
		this.groupsGridOption.setGridData(this.permission.groups);
		this._filterAvailableGroups();
	}

	_deleteSelectedUsers() {
		let selectedUsers = this.usersGridOption.api.selection.getSelectedRows();
		selectedUsers.forEach((user) => {
			//console.log('remove', user)
			if (user.name !== 'admin') {
				_.remove(this.permission.users, user);
			} else {
				this.jFrogNotifications.create({
					error: 'Removing admin from the Admins Permission Rule is not' +
					' allowed'
				});
			}


		});
		this.usersGridOption.setGridData(this.permission.users);
		this._filterAvailableUsers();
	}

	_getGroupsActions() {
		return [
			{
				icon: 'icon icon-clear',
				tooltip: 'Remove',
				callback: row => this._deleteGroup(row)
			}
		];
	}

	_deleteGroup(row) {
		this.permission.groups = _.remove(this.permission.groups, (g) => {
			return g.name != row.name;
		});

		this._filterAvailableGroups();

	}

	_getUsersActions() {
		return [
			{
				icon: 'icon icon-clear',
				tooltip: 'Remove',
				callback: row => this._deleteUser(row),
				visibleWhen: row => row.name !== 'admin'
			}
		];
	}

	_deleteUser(row) {
		_.remove(this.permission.users, row);
		this.usersGridOption.setGridData(this.permission.users);

		this._filterAvailableUsers();
	}

	_transformForEdit(obj) {
		//console.log('about to transform for edit with the followin obj :',obj)
		if (!this.transformed) {
			this.permission.users = [];
			this.permission.groups = [];
			this.permission.resource_type = obj.resource_type;
			this.permission.groups = [];
			this.permission.resources = [];

			if (obj.actions) {
				if (obj.actions.users) {
					if (obj.actions.users.length) {
						this._filterAvailableUsers(obj.actions.users);
					}
				}
			}
			if (obj.actions) {
				if (obj.actions.groups) {
					if (obj.actions.groups.length) {
						this._filterAvailableGroups(obj.actions.groups);
					}
				}
			}


			if (obj.custom_data.repositories) {
				_.each(obj.custom_data.repositories, (r) => {
					//console.log('findWhere Results are : ', _.find(this.allResourcesFlatten, {name: r.name}))
					let current = _.find(this.allResourcesFlatten, {name: r.name}) || {
						name: r.name,
						_iconClass: 'icon' + ' icon-local-repo ghost',
						type: 'local'
					};
					//console.log('current is',current)
					if (current) {
						this.permission.resources.push(current);
					}
				});
			}
			if (obj.custom_data.builds) {
				_.each(obj.custom_data.builds, (b) => {
					//console.log('about to push Build', b)
					//console.log('findWhere Results for builds are are : ', _.find(this.allResourcesFlatten,
					// {name: b.name}))
					let current = _.find(this.allResourcesFlatten, {name: b.name}) || {
						name: b.name,
						_iconClass: 'icon' + ' icon-builds-new ghost',
						type: 'build'
					};
					this.permission.resources.push(current);
				});
			}

			/*this._filterAvailableUsers();
			this._filterAvailableGroups();*/
			this.transformed = true;
			this.XrayModelSaver.save();

			this.getFilterResources();
		}


	}

	_transformResourcesForEdit(obj) {
		if (obj.custom_data.repositories) {
			_.each(obj.custom_data.repositories, (r) => {
				//console.log('about to push Resource', r)
				//console.log('findWhere Results are : ', _.find(this.allResourcesFlatten, {name: r.name}))
				let current = _.find(this.allResourcesFlatten, {name: r.name}) || r.name;

				this.permission.resources.push(current);
			});
		}
		if (obj.custom_data.builds) {
			_.each(obj.custom_data.builds, (b) => {
				//console.log('about to push Build', b)
				//console.log('findWhere Results for builds are are : ', _.find(this.allResourcesFlatten,
				// {name: b.name}))
				let current = _.find(this.allResourcesFlatten, {name: b.name}) || {
					name: b.name, _iconClass: 'icon' +
					' icon-builds-new ghost', type: 'build'
				};
				this.permission.resources.push(current);
			});
		}
	}

	_transformForSave(obj) {

		let tmpObj = {};
		tmpObj.name = obj.name;
		tmpObj.resource_type = obj.resource_type;
		tmpObj.actions = {};
		tmpObj.actions.users = [];
		tmpObj.actions.groups = [];
		tmpObj.custom_data = {};
		tmpObj.custom_data.repositories = [];
		tmpObj.custom_data.builds = [];
		if (obj.resource_type !== 'global') {

			tmpObj.custom_data.repositories = _.filter(this.permission.resources, (r) => {

				return r.type && r.type.toLowerCase() !== 'build';
			});
			tmpObj.custom_data.builds = _.filter(this.permission.resources, (r) => {
				return r.type && r.type.toLowerCase() === 'build';
			});

			tmpObj.custom_data.repositories = _.map(tmpObj.custom_data.repositories,
				i => _.pick(i, 'name', 'type', 'pkg_type'));
			tmpObj.custom_data.builds = _.map(tmpObj.custom_data.builds, i => _.pick(i, 'name', 'type'));
		}
		tmpObj.actions.groups = _.map(this.permission.groups, i => _.pick(i, 'name', 'rules'));
		tmpObj.actions.users = _.map(this.permission.users, i => _.pick(i, 'name', 'rules'));

		if (this.permission.resource_type !== 'global') {
			_.each(tmpObj.actions.groups, (val, key) => {
				if (tmpObj.actions.groups[key].rules) {
					delete tmpObj.actions.groups[key].rules.admin;
					delete tmpObj.actions.groups[key].rules.view_reports;
                    delete tmpObj.actions.groups[key].rules.manage_policies;
				}

			});

			_.each(tmpObj.actions.users, (val, key) => {
				if (tmpObj.actions.users[key].rules) {
					delete tmpObj.actions.users[key].rules.admin;
					delete tmpObj.actions.users[key].rules.view_reports;
                    delete tmpObj.actions.users[key].rules.manage_policies;
				}
			});
		}
		return tmpObj;
	}

	save() {


		if (this.savePending) {
			return;
		}

		//this.savePending = true;
		let payload = this._transformForSave(this.permission);
		// tmp

		if (this.newPermission) {
			this.XrayModelSaver.save();
			this.permissionsDao.create(payload).$promise.then((response) => {
				this.savePending = false;
				if (response.status == 200 || response.status == 201) {
					this.$state.go('^.permissions');
				}
			}).catch(() => this.savePending = false);
		}
		else {
			this.XrayModelSaver.save();
			this.permissionsDao.update({}, payload).$promise.then(() => {
				this.savePending = false;
				//console.log('moving')
				this.$state.go('^.permissions');
			}).catch(() => this.savePending = false);
		}
	}

	_pickFields(data, arrOfFields) {
		return _.map(data, _.partial(_.ary(_.pick, arrOfFields.length), _, arrOfFields));

	}

	isDisableRepositories() {
		return !this.user.isAdmin() && !this.newPermission;
	}

	isDisable(row) {
		return row.icon_class === 'icon-admin-new';
	}

	isDisableManager(row) {
		return row.name === this.user.name;
	}

	_filterAvailableGroups(groups) {


		if (groups) {

			_.each(groups, (g) => {
				this.permission.groups.push(g);
			});
		}

		let availabileGroups = _.filter(this.allGroups, (group) => {
			return _.find(this.permission.groups, {name: group.name}) === undefined;
		});

		this.availableGroups = _.sortBy(availabileGroups, 'name');

		this.groupsGridOption.setGridData(_.sortBy(this.permission.groups, 'name'));
	}

	_filterAvailableUsers(users) {


		if (users) {
			_.each(users, (u) => {
				if (u.rules) {
					if (u.rules.admin) {
						u.rules.manage_component = u.rules.manage_watch_issues = u.rules.view_component = u.rules.view_watch_issues = u.rules.view_reports = true;
					}
				}
				this.permission.users.push(u);
			});
		}

		let availableUsers = _.filter(this.allUsers, (user) => {
			return _.find(this.permission.users, {name: user.name}) === undefined;
		});

		this.availableUsers = _.sortBy(availableUsers, 'name');

		_.each(this.availableUsers, (u) => {

			if (u.realm) {
				let userRealm = u.realm;
                if (userRealm == 'internal' || userRealm == 'oauth') {
					userRealm = 'artifactory';
				}
				u.icon_class = `icon-${userRealm}`;
				u.icon_tooltip = userRealm;

			} else {
				u.icon_class = 'icon-xray-new';
			}
			if (u.name === 'admin') {
				u.clickable = false;
				u.icon_class = 'icon-xray-admin';
				u.icon_tooltip = 'Users with admin privileges cannot be added to a Permission Target\n';
			}
		});
		this.usersGridOption.setGridData(_.sortBy(this.permission.users, 'name'));
	}

	_filterAvailableResources() {

		//console.log('filtering reosurces')
		if (_.isEqual(this.resourceFilter.currentInstance, this.resourceFilter.currentRepoType) && _.isEqual(
				this.resourceFilter.currentInstance, this.resourceFilter.currentResourceType)) {
			this.filteredResources = _.filter(this.allResourcesFlatten, (r) => {
				return _.find(this.permission.resources, {name: r.name}) === undefined;
			});
		} else {
			this.filteredResources = _.filter(this.filteredResources, (r) => {
				return _.find(this.permission.resources, {name: r.name}) === undefined;
			});

		}

	}

	typeChanged() {
		this._createGroupsGrid();
		this._filterAvailableGroups();
		this._createUsersGrid();
		this._filterAvailableUsers();

	}
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/permissions/permissions_form.controller.js